import { Grid, Typography, Paper, Box } from '@mui/material';
import { APPLICATION_STATUS_LIST } from '../../../../constants/statusList';
import { APPLICATION_STATUS_COLORS } from '../../../../constants/statusColors';
import { useNavigate } from 'react-router-dom';
import type { Application } from '../../types/application';

interface Props {
  applications: Application[];
}

const StatusSummaryGrid = ({ applications }: Props) => {
  const navigate = useNavigate();

  const statuses = APPLICATION_STATUS_LIST.filter((s) => s !== '전체');
  const countMap: Record<string, number> = {};
  statuses.forEach((s) => {
    countMap[s] = applications.filter((a) => a.status === s).length;
  });

  return (
    <Box sx={{ mb: 3 }}>
      <Typography fontWeight={700} sx={{ fontSize: '0.95rem', color: '#0f172a', mb: 1.5 }}>
        상태별 현황
      </Typography>
      <Grid container spacing={1.5}>
        {statuses.map((status) => {
          const color = APPLICATION_STATUS_COLORS[status] || '#94a3b8';
          const count = countMap[status];
          return (
            <Grid item xs={6} sm={4} md key={status}>
              <Paper
                elevation={0}
                onClick={() => navigate(`/admin/orders?status=${status}`)}
                sx={{
                  p: 0, borderRadius: 2.5, display: 'flex', alignItems: 'stretch',
                  cursor: 'pointer', border: '1px solid #f0f0f0',
                  transition: 'all 0.12s',
                  '&:hover': { borderColor: color, boxShadow: `0 2px 8px ${color}18` },
                }}
              >
                <Box sx={{ width: 4, borderRadius: 2.5, bgcolor: color, flexShrink: 0 }} />
                <Box sx={{
                  flex: 1, px: 1.5, py: 1.2,
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                  <Typography sx={{ fontWeight: 600, fontSize: '0.82rem', color: '#334155' }}>
                    {status}
                  </Typography>
                  <Typography sx={{ fontWeight: 800, fontSize: '1.1rem', color, letterSpacing: '-1px' }}>
                    {count}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default StatusSummaryGrid;
